import { AddIntegrationFormDrawer } from '@modules/integrationsV2/components/AddIntegrationFormDrawer';
import { IntegrationsActionType } from '@modules/integrationsV2/store/integrationsActionType';
import { useIntegrationsStore } from '@modules/integrationsV2/store/integrationsStore';

export const SelectedAddIntegrationFormDrawer = () => {
  const dispatch = useIntegrationsStore(({ dispatch }) => dispatch);
  const selectedIntegrationFormToConnect = useIntegrationsStore(
    ({ view }) => view.selectedIntegrationFormToConnect,
  );

  const onDrawerClose = () => {
    dispatch({
      type: IntegrationsActionType.SET_VIEW,
      payload: {
        selectedIntegrationFormToConnect: null,
      },
    });
  };

  return (
    <AddIntegrationFormDrawer
      integrationChannel={selectedIntegrationFormToConnect?.integrationChannel}
      integrationType={selectedIntegrationFormToConnect?.integrationType}
      isOpen={!!selectedIntegrationFormToConnect}
      onDrawerClose={onDrawerClose}
    />
  );
};
